// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input_calendar.mid[data-v-74cf5f1e], .input_calendar.mid input[data-v-74cf5f1e] {\n    width: 200px;\n}\ndiv.input_error .inp_cal[data-v-74cf5f1e] {\n  border: 1px solid #f2084f !important;\n}\n", ""]);
// Exports
module.exports = exports;
